export * from './datetime'

Object.byString = function (o, s) {
  if (!s || !o) return undefined // check if s is nullish
  // eslint-disable-next-line
  s = s.replace(/\[(\w+)\]/g, '.$1') // convert indexes to properties
  // eslint-disable-next-line
  s = s.replace(/^\./, '') // strip a leading dot
  const a = s.split('.')
  // eslint-disable-next-line
  for (let i = 0, n = a.length; i < n; ++i) {
    const k = a[i]
    if (k in o) {
      // eslint-disable-next-line
      o = o[k]
    } else {
      return
    }
  }
  return o
}

Object.isEmpty = (obj) => {
  if (!obj) return undefined
  return Object.keys(obj).length === 0 && obj.constructor === Object
}

export const storage = {
  getToken: () => JSON.parse(window.localStorage.getItem('token')),
  setToken: (token) =>
    window.localStorage.setItem('token', JSON.stringify(token)),
  clearToken: () => window.localStorage.removeItem('token')
}

export const valueToPercent = (value, min, max) => {
  return (((value - min) * 100) / (max - min)).toFixed(6)
}
